import { useQuery } from 'react-query';
import { AadeBookInvoiceType } from '../../../interfaces/myData.interface';
import { apiRQ } from '../../api';

const fetchReceivedDocByMark = async (mark: string): Promise<AadeBookInvoiceType | null> => {
  const markNum = Number(mark);
  const params = { mark: markNum - 1, maxMark: markNum };
  const resp = await apiRQ.get('/gsis/recipient-docs', { params });
  const invoice = resp.data?.data?.RequestedDoc?.invoicesDoc?.invoice;
  if (!invoice) return null;
  return Array.isArray(invoice) ? invoice[0] : invoice;
};

export const useReceivedDocByMark = (mark: string | undefined, enabled: boolean) => {
  return useQuery<AadeBookInvoiceType | null, Error>(
    ['receivedDocByMark', mark],
    () => fetchReceivedDocByMark(mark!),
    {
      enabled: !!mark && enabled,
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
  );
};
